module.exports = __webpack_public_path__ + "img/apa.988521b9.jpg";